/**
 * Time field formatter
 */

import {useDateTime} from '@hconnect/tuc-processes/fields'
import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'

import {formattedDate} from '../../../../../Pages/Order/OrderDetails/components/utils'

import type {FieldFormatter} from './types'
import {createValueArray} from './utils'

export const useTimeFormatter = (): FieldFormatter => {
  const {dateTime, defaultDateTime} = useDateTime()
  const timeState = useChangeableField({field: 'dateTime', fieldPart: 'time'})

  return (context) => {
    const {t, language} = context
    const requiresApproval = timeState.state === 'requireDispatchConfirmation'
    const hasChanges = timeState.isDirty

    // Format like TimeFieldButton: uses formattedDate utility
    const formatTime = (dt: unknown): string | null => {
      if (!dt || !Array.isArray(dt) || !dt[0]) return null
      const [, time] = formattedDate(dt[0], language)
      return time
    }

    const oldValue = formatTime(defaultDateTime)
    const newValue = formatTime(dateTime)

    const values = createValueArray(
      oldValue,
      newValue,
      hasChanges,
      t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified')
    )

    return {values, requiresApproval, hasChanges}
  }
}
